import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { verifyToken } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
    const [state, setState] = useState({ loading: true, authed: false });
    const location = useLocation();

    useEffect(() => {
        verifyToken().then((data) => setState({ loading: false, authed: !!data }));
    }, []);

    if (state.loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
                <div className="text-center">
                    <div className="w-2 h-2 bg-brand rounded-full animate-pulse-dot mx-auto"></div>
                    <div className="mt-4 text-xs font-mono uppercase tracking-[0.2em] text-ink-muted">Verifica sessione…</div>
                </div>
            </div>
        );
    }
    if (!state.authed) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    return children;
}
